
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
name: 'i-search',
components: {
Group,
Cell,
},
props: {
placeholder: {
type: String,
},
noResult: {
type: Boolean,
default(){
return false;
}
},
noResultStr: {
type: String,
},
showResult: {
type: Boolean,
default: false,
}
},
data(){
return {
keyWord: '',
isShowClear: false,
};
},
watch: {
keyWord: {
handler(cur){
this.$emit('on-search', cur);
}
}
},
methods: {
onCancel(){
this.$emit('on-cancel');
},

onFocus(){
this.isShowClear = true;
this.$emit('on-focus');
},

onBlur(){
this.isShowClear = false;
},

onClear(){
this.keyWord = '';
},
},
}



// WEBPACK FOOTER //
// ./src/components/ISearch/ISearch.vue